module.exports = __webpack_public_path__ + "static/Supermercado-560503e80a1c1358a36a624ab90b2449.jpg";